async function isUKVisitor() {
  try {
    const res = await fetch("/browsing_context_suggestions.json");
    const data = await res.json();
    return data?.detected_values?.country?.handle === "GB";
  } catch {
    return false;
  }
}

class ShippingBar extends HTMLElement {
  async connectedCallback() {
    const isUK = await isUKVisitor();
    if (!isUK) {
      this.remove();
      return;
    }
  }
}

customElements.define("shipping-bar", ShippingBar);
